import { render, staticRenderFns } from "./FormCoordinates.vue?vue&type=template&id=200d9b2a&scoped=true"
import script from "./FormCoordinates.vue?vue&type=script&lang=js"
export * from "./FormCoordinates.vue?vue&type=script&lang=js"
import style0 from "./FormCoordinates.vue?vue&type=style&index=0&id=200d9b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d9b2a",
  null
  
)

export default component.exports